import { ComponentType, FC } from 'react';
import { Flex, FlexProps, Icon, IconProps } from '@chakra-ui/react';

type CircleIconPresenterProps = FlexProps & {
  icon: ComponentType;
  iconProps?: IconProps;
};

export const CircleIconPresenter: FC<CircleIconPresenterProps> = ({
  icon,
  iconProps,
  ...props
}) => (
  <Flex
    alignItems="center"
    bg="white"
    borderRadius="full"
    boxSize={24}
    justifyContent="center"
    shadow="xl"
    {...props}
  >
    <Icon as={icon} boxSize={16} {...iconProps} />
  </Flex>
);
